<app-page-header></app-page-header>
<app-breadcromb pageName="Reset Password"></app-breadcromb>
<!-- Login Area Start -->
<section class="jobguru-login-area section_70">
  <div class="container">
    <div class="row">
      <div class="col-md-12">
        <div class="login-box">
          <div class="login-title">
            <h3>Change Password</h3>
          </div>
          <form [formGroup]="resetForm" (ngSubmit)="updatePassword()">
            <div class="single-login-field">
              <input type="password" formControlName="oldPassword" placeholder="Current password">
              <div class="text-danger" *ngIf="r.oldPassword.touched && r.oldPassword.invalid">
                <span *ngIf="r.oldPassword.errors.required">Current password is a required field</span>
              </div>
            </div>
            <div class="single-login-field">
              <input type="password" formControlName="password" placeholder="New password">
              <div class="text-danger" *ngIf="r.password.touched && r.password.invalid">
                <span *ngIf="r.password.errors.required">New password is a required field</span>
              </div>
              <div class="text-danger" *ngIf="r.password.touched && r.password.invalid">
                <span *ngIf="r.password.errors.minlength">Password should be at least 8 characters</span>
              </div>
            </div>
            <div class="single-login-field">
              <input type="password" formControlName="newPasswordConfirmation" placeholder="Repeat new password">
              <div class="text-danger" *ngIf="r.newPasswordConfirmation.touched && r.newPasswordConfirmation.invalid">
                <span *ngIf="r.newPasswordConfirmation.errors.required">Password confirmation is a required field</span>
              </div>
              <div class="text-danger" *ngIf="r.newPasswordConfirmation.touched && r.newPasswordConfirmation.invalid">
                <span *ngIf="r.newPasswordConfirmation.errors.passwordMisMatch">Password do not match</span>
              </div>
            </div>
            <div class="single-login-field">
              <button [disabled]="loading" class="btn btn-primary btn-xs" type="submit">
                <span *ngIf="loading" class="spinner-border spinner-border-sm mr-1"></span>
                Change Password
              </button>
              <div *ngIf="error" class="alert alert-danger mt-3 mb-0">{{error}}</div>
            </div>
          </form>
        </div>
      </div>
    </div>
  </div>
</section>
<!-- Login Area End -->
